/*
  angular-photoswipe v0.2.0
  (c) 2016 Massimiliano Sartoretto <massimilianosartoretto@gmail.com>
  License: MIT
*/
import template from './template.pug';

'format amd';
/* global define */

(function () {
  'use strict';

  function ngPhotoswipe(angular) {
    'ngInject';
    return angular
      .module('ngPhotoswipe', [])
      .directive('ngPhotoswipe', ngPhotoswipeDirective);
    function ngPhotoswipeDirective($compile, $document, $stateParams) {
      'ngInject';
      return {
        restrict: 'AE',
        replace: true,
        scope: {
          open: '<',
          options: '<',
          slides: '<',
          slideSelector: '@',
          onClose: '&'
        },
        link: linkFn
      };
      function linkFn(scope) {
        const tmpl = template;
        // 
        scope.start = function() {
          scope.open = true;
          startGallery();
        };

        var startGallery = () => {
          // append teplate

          $document.find('body').append($compile(tmpl)(scope));
          $stateParams.stopKeyBinding = true;

          // prevent empty photos

          scope.slides = scope.slides.filter(e => e);
          if(scope.slides && !scope.slides.length) {
            scope.gallery = null;
            $stateParams.stopKeyBinding = false;
          }

          // slect template
          var pswpElement = document.querySelectorAll('.pswp')[0];

          // init photo swipe

          if (angular.isUndefined(scope.options.getThumbBoundsFn) &&
              angular.isDefined(scope.slideSelector)) {
            scope.options = angular.merge({}, {

              getThumbBoundsFn: function(index) {
                var thumbnail = document.querySelectorAll(scope.slideSelector)[index];
                var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                var rect = thumbnail.getBoundingClientRect();
                return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
              }

            }, scope.options);
          }
          scope.gallery = new window.PhotoSwipe(pswpElement, window.PhotoSwipeUI_Default || false, scope.slides, scope.options);
          scope.gallery.init();
          scope.item = scope.gallery.currItem;
          scope.gallery.listen('destroy', function () {
            $stateParams.stopKeyBinding = false;
            scope.safeApply(function () {
              (scope.onClose({$event: {}}) || angular.noop)();
            });
          });

          // scope.gallery.listen('afterChange', function () {
          //   // scope.safeApply(function () {
          //   //   debugger
          //   //   // scope.item = scope.gallery.currItem.filter(e => e != null);
          //   // });
          // });

          scope.gallery.listen('imageLoadComplete', function(index, item) {
            scope.gallery.init();
          });

        };

        scope.$watch('open', function (nVal, oVal) {
          if (nVal != oVal) {
            if (nVal) {
              startGallery();
            }
          } else if (!nVal && scope.gallery) {
            $stateParams.stopKeyBinding = false;
            scope.gallery.close();
            scope.gallery = null;
          }
        });

        scope.safeApply = function(fn) {
          var phase = this.$root.$$phase;
          if(phase == '$apply' || phase == '$digest') {
            if(fn && (typeof(fn) === 'function')) {
              fn();
            }
          } else {
            this.$apply(fn);
          }
        };
        scope.$on('destroy', function () {
          scope.gallery = null;
          $stateParams.stopKeyBinding = false;
        });
      }
    }


  }

  if (typeof define === 'function' && define.amd) {
    define(['angular', 'photoswipe'], ngPhotoswipe);
  } else if (typeof module !== 'undefined' && module && module.exports) {
    ngPhotoswipe(angular, require('photoswipe'));
    module.exports = 'ngPhotoswipe';
  } else {
    ngPhotoswipe(angular, (typeof global !== 'undefined' ? global : window).Photoswipe);
  }
})();
